Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var feedback = require('@sentry-internal/feedback');

/** Add a widget to capture user feedback to your application. */
var feedbackSyncIntegration = feedback.buildFeedbackIntegration({
  getModalIntegration: function getModalIntegration() {
    return feedback.feedbackModalIntegration;
  },
  getScreenshotIntegration: function getScreenshotIntegration() {
    return feedback.feedbackScreenshotIntegration;
  }
});
exports.feedbackSyncIntegration = feedbackSyncIntegration;